import { BetaBadge } from "@components/custom/content";

import "./ai-modal-footer-note.scss";

export const AiModalFooterNote = () => {
  return (
    <div className="ai-modal-footer-note">
      <div className="ai-modal-footer-note__brand">
        <span>Powered by Transfr Intelligence</span>
        <BetaBadge />
      </div>
      <p className="ai-modal-footer-note__disclaimer">
        AI might make mistakes. Please double check responses.
      </p>
    </div>
  );
};
